"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useIPaperFullscreen = void 0;
var _logger = require("@ori/logger");
var _presentationHooks = require("@ori/presentation-hooks");
var _react = require("react");
var _styles = require("../components/FullscreenButton/styles");
/**
 * Simple hook to toggle fullscreen on the IPaper root element.
 * Uses the browser Fullscreen API and tracks whether the IPaper root is currently fullscreen.
 */ const useIPaperFullscreen = ()=>{
    const logger = (0, _logger.useLogger)('useIPaperFullscreen');
    const [isFullscreen, setIsFullscreen] = (0, _react.useState)(false);
    const toggleFullscreen = (0, _react.useCallback)(()=>{
        var _miniShoppingBagFadingWrapper_parentElement;
        setIsFullscreen((previousValue)=>!previousValue);
        const miniShoppingBagFadingWrapper = document.querySelector('[data-testid="Checkout-mini-shopping-bag-fading-wrapper"]');
        miniShoppingBagFadingWrapper === null || miniShoppingBagFadingWrapper === void 0 ? void 0 : (_miniShoppingBagFadingWrapper_parentElement = miniShoppingBagFadingWrapper.parentElement) === null || _miniShoppingBagFadingWrapper_parentElement === void 0 ? void 0 : _miniShoppingBagFadingWrapper_parentElement.classList.toggle(_styles.MINIBAG_FULLSCREEN_CLASSNAME);
    }, []);
    const enter = (0, _react.useCallback)(async ()=>{
        try {
            await document.documentElement.requestFullscreen();
        } catch (error) {
            // requestFullscreen can be rejected (blocked by browser or not allowed)
            logger.warn('Failed to enter fullscreen', {
                error: JSON.stringify(error)
            });
        }
    }, [
        logger
    ]);
    const exit = (0, _react.useCallback)(async ()=>{
        if (document.fullscreenElement) {
            try {
                await document.exitFullscreen();
            } catch (error) {
                // exitFullscreen can be rejected (blocked by browser or not allowed)
                logger.warn('Failed to exit fullscreen', {
                    error: JSON.stringify(error)
                });
            }
        }
    }, [
        logger
    ]);
    const toggle = (0, _react.useCallback)(()=>{
        var _document_fullscreenElement;
        if (((_document_fullscreenElement = document.fullscreenElement) === null || _document_fullscreenElement === void 0 ? void 0 : _document_fullscreenElement.id) === document.documentElement.id) {
            void exit();
        } else {
            void enter();
        }
    }, [
        enter,
        exit
    ]);
    const events = (0, _react.useMemo)(()=>[
            {
                name: 'fullscreenchange',
                listener: toggleFullscreen
            }
        ], [
        toggleFullscreen
    ]);
    (0, _presentationHooks.useGlobalEvents)(events);
    return {
        isFullscreen,
        enter,
        exit,
        toggle
    };
};
exports.useIPaperFullscreen = useIPaperFullscreen;
